// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"73302d72","117":"6f708601","161":"e1319bc5","209":"e1f55257","478":"4d30222f","625":"03cd8ab6","675":"b537e5a9","745":"4cdb9fc4","922":"a9748d02","964":"ee699626"}[chunkId] + ".chunk.js";
};